import firebase from "firebase/app";
import "firebase/database";
import "firebase/auth";
import "firebase/storage";


const config = {
  apiKey: "AIzaSyC6zxpjRHzw37yNEKL6yfZhXxFESn3mUN0",
  authDomain: "species-classification-d75db.firebaseapp.com",
  databaseURL: "https://species-classification-d75db-default-rtdb.firebaseio.com",
  projectId: "species-classification-d75db",
  storageBucket: "species-classification-d75db.appspot.com",
  messagingSenderId: "296167187128",
  appId: "1:296167187128:web:0e4288cd7175a8a5ca8a4d",
  measurementId: "G-8T3P9PZGC7"
};

firebase.initializeApp(config);

export const database = firebase.database();
export const storage = firebase.storage();
export const provider = new firebase.auth.GoogleAuthProvider();
export const auth = new firebase.auth();


export default firebase;
